import { useAccountLimitsContext } from "../../../context/account-limit-context";
import { listenEnabled } from "../../../generic/server/supabase-account-service";

import type { RecentlyEditedType } from "../../hooks/use-recently-edited";

export type ContentTab = RecentlyEditedType | "all";

const TABS: { value: ContentTab; label: string; search: string }[] = [
  { value: "all", label: "All", search: "Search all Content" },
  { value: "communication", label: "Communications", search: "Search Communications" },
  { value: "survey", label: "Surveys", search: "Search Surveys" },
  { value: "digital_asset", label: "Content Library", search: "Search Content Library" },
];

/** The kinds of content this account can narrow its feed and search to, All first. */
export function useContentTabs(): typeof TABS {
  // Surveys are Listen's, so their tab is left out without it.
  const { listen_entitlement } = useAccountLimitsContext();
  return listenEnabled(listen_entitlement) ? TABS : TABS.filter(({ value }) => value !== "survey");
}
